// removed by extract-text-webpack-plugin
module.exports = {"root":"_7c487050","opened":"_598b7dd9","content":"_5f9c7040","info":"_6fb82afc","text":"_51fec0ff","desc":"_747bcb0f","buttonText":"c01d619f","button":"c6d1681e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InvitationBox/index.styl
// module id = 2252
// module chunks = 39